import axios from "axios";
import { Loader } from "rsuite";
import { toast } from "react-toastify";
import { useEffect, useState } from "react";

import AuthService from "../../../services/auth.service";
import UserFormUpdate from "../elements/user_form_update/userFormUpdate";

import { UserTransactions } from "./userTransactions";
import { SubscriptionActiveTab } from "./subscriptionActiveTab";

import "./subscription.scss";
import "react-toastify/dist/ReactToastify.css";

const APP_URL = process.env.APP_URL;

const Subscription = () => {
  const [, setIsLoading] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const [activeTabContent, setActiveTabContent] = useState(null);

  const tabs = [
    { title: "رژیم های فعال", params: { expired: false } },
    { title: "رژیم های قبلی", params: { expired: true } },
  ];

  useEffect(() => {
    sync(activeTab);
    const interval = setInterval(() => sync(activeTab, false), 120000);
    return () => clearInterval(interval);
  }, [activeTab]);

  return (
    <>
      <UserFormUpdate />
      <div className="d-flex justify-content-between">
        <div className="text-bold" style={{ fontSize: "1rem" }}>
          رژیم های من
        </div>
        <UserTransactions />
      </div>

      <div className="tabs-container" style={{ marginTop: "2rem" }}>
        <div className="tabs subscription-tabs">
          {tabs.map((tab, tabIndex) => (
            <div
              className={`tab ${activeTab === tabIndex ? "active-tab" : ""}`}
              key={tabIndex}
              onClick={() => changeTab(tabIndex)}
            >
              <div className="tab-title">{tab.title}</div>
              <div className="tab-line"></div>
            </div>
          ))}
        </div>

        <div className="tab-content">
          <div className="card tab-content-card">
            {activeTabContent ? (
              renderContent()
            ) : (
              <Loader backdrop content="درحال دریافت اطلاعات ..." vertical />
            )}
          </div>
        </div>
      </div>
    </>
  );

  function renderContent() {
    if (activeTabContent.length === 0) {
      return (
        <div className="empty-data" style={{ marginTop: "2rem" }}>
          <p>اطلاعاتی یافت نشد!</p>
        </div>
      );
    }
    return (
      <div className="subscriptions">
        {activeTabContent.map((subscription, index) => (
          <SubscriptionActiveTab
            subscription={subscription}
            subscriptionIndex={index}
          />
        ))}
      </div>
    );
  }

  function changeTab(tabIndex) {
    setActiveTab(tabIndex);
    setActiveTabContent(null);
    sync(tabIndex);
  }

  function sync(tabIndex, hasLoading = true) {
    const config = {
      headers: { Authorization: `Bearer ${AuthService.getAccessToken()}` },
      params: tabs[tabIndex].params,
    };

    if (hasLoading) setIsLoading(true);

    axios
      .get(`${APP_URL}/api/v6/subscriptions`, config)
      .then((response) => {
        setActiveTabContent(response.data.result);
        setIsLoading(false);
      })
      .catch(handleError);
  }

  function handleError(error) {
    setIsLoading(false);
    if (!error.response) return;

    const statusCode = error.response.status;
    if (statusCode === 422) {
      const { errors } = error.response.data;
      for (const key in errors) showErrorToast(errors[key][0]);
    } else if (statusCode === 401) {
      AuthService.logout();
      window.location.replace("/");
    }
  }

  function showErrorToast(message) {
    toast.error(message, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "light",
    });
  }
};

export default Subscription;
